import React, {useState} from 'react';
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import {
    isValidMobile,
    numOnKeyDown,
    saveAccessToken,
    sleep,
    validPassword
} from "../../../../../tools/helper";
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Button from "@mui/material/Button";
import {IS_AUTH, USER_DATA} from "../../../../../redux/action/type.action";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router";
import {GetState, SetState} from "../../../../../redux/reduxhelper";
import PasswordInput from "../../../../../components/Admin/passwordInput/PasswordInput";
import {loginToAccountApi} from "../../../../../api/AdminApi";
import {errorMessage} from "../../../../../tools/messages";


const LoginByPassword = ({setSlideIndex}) => {
    const userData = GetState(USER_DATA, {
        mobile: '',
        password: ''
    });
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const loginToMyAccount = async (event) => {
        event.preventDefault();

        if (!isValidMobile(userData?.mobile)) {
            errorMessage('موبایل معتبر نیست');
            return false;
        }


        if (!validPassword(userData?.password)) {
            errorMessage('پسورد معتبر نیست')
            return false;
        }

        try {
            const res = await loginToAccountApi({
                mobile: userData?.mobile,
                password: userData?.password
            })

            let access_token = res?.data?.data?.access_token;
            // save access token
            await saveAccessToken(access_token);
            await sleep(200)
            dispatch(SetState(IS_AUTH, true))

            console.log(access_token)

            // navigate to dashboard
        } catch (e) {
            // log error
        }
    };


    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    }
    const handleLogin = () => {


    }
    const onHandleChangeInput = () => {

    }
    const [mobileErrorMsg, setMobileErrorMsg] = useState("");
    const {PasswordErrorMsg, setPasswordErrorMsg} = useState("");


    return (
        <Grid>
            <Box
                sx={{
                    my: 8,
                    mx: 4,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'start',

                }}
            >
                <Typography sx={{fontFamily: "IRANSan", mb: 4, fontSize: {xs: '1rem', sm: '1rem', md: '2rem'}}}
                            component="h4"
                            variant="h6">
                    به پنل ادمین شادزی خوش آمدید
                </Typography>
                <Box component="form" noValidate onSubmit={loginToMyAccount}>
                    <TextField onKeyDown={numOnKeyDown}
                               error={mobileErrorMsg !== ''}
                               autoComplete={'off'}
                               fullWidth
                               value={userData?.mobile}
                               onChange={(e) => {
                                   if (!isValidMobile(e?.target?.value))
                                       setMobileErrorMsg('شماره موبایل باید 11 رقم باشد')
                                   else
                                       setMobileErrorMsg('');


                                   dispatch(SetState(USER_DATA, {...userData, mobile: e?.target?.value}));
                               }}

                               sx={{my: 1}}
                               helperText={mobileErrorMsg}
                               type="number"
                               autoFocus
                               placeholder="شماره موبایل"
                               description="Password must include at least one letter, number and special character"
                    />

                    <PasswordInput
                        fullWidth
                        value={userData?.password}
                        onChange={(e) => dispatch(SetState(USER_DATA, {...userData, password: e?.target?.value}))}
                        type="primary"
                        sx={{my: 1}}
                        placeholder="رمز عبور"
                        description="Password must include at least one letter, number and special character"


                    />

                    <Grid sx={{
                        flexDirection: {xs: 'column', sm: 'column', md: 'row',},
                        gap: 8,
                        display: {xs: 'block', sm: 'block,start ', md: 'flex'},
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        textAlign: {xs: 'start'},


                    }}>


                        <FormControlLabel style={{marginRight: 0}}
                                          label="مرا به خاطر بسپار"
                                          margin='normal'
                                          labelPlacement="end"
                                          control={<Checkbox size={"small"} value="remember" sx={{
                                              paddingLeft: 0,
                                              marginRight: "0",
                                              '&.Mui-checked': {
                                                  color: "#5D5FEF",
                                              },
                                          }}/>}


                        />

                        {/*<Link onClick={() => navigate('/admin/recovery')} sx={{*/}
                        {/*    display: {xs: 'block', md: 'flex', lg: 'flex'},*/}
                        {/*    justifyContent: {sx: 'flex-end', sm: 'flex-end', color: '#592EA9'}*/}
                        {/*}}*/}
                        {/*      underline="none" href="#" variant="body2">*/}
                        {/*    {"رمز عبور خود را فراموش کرده اید؟"}*/}
                        {/*</Link>*/}


                    </Grid>

                    {/*<Grid sx={{*/}
                    {/*    display: 'flex',*/}
                    {/*    my: 1,*/}
                    {/*    justifyContent: 'flex-start'*/}
                    {/*}}>*/}
                    {/*    <Link onClick={() => setSlideIndex(1)}*/}

                    {/*          underline="none" href="#"*/}
                    {/*          variant="body2">*/}
                    {/*        ورود با رمز یکبار مصرف*/}
                    {/*    </Link>*/}
                    {/*</Grid>*/}
                    <Button
                        onClick={() => loginToMyAccount}
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{
                            my: 2,
                            padding: '12px',
                            borderRadius: '40px',
                            backgroundColor: '#592EA9',
                            ":hover": {bgcolor: '#5D5FEF'}
                        }}
                    >
                        وارد شو
                    </Button>

                    {/*<Grid sx={{*/}
                    {/*    width: '100%',*/}
                    {/*    display: {xs: 'grid', sm: 'grid', md: 'flex'},*/}
                    {/*    justifyContent: {xs: 'start', sm: 'start', md: 'space-between'},*/}
                    {/*    textAlign: {xs: 'start', sm: 'end'}*/}
                    {/*}}>*/}

                    {/*    <Link sx={{color: '#797979'}} underline="none" variant="body2">*/}
                    {/*        حساب کاربری شادزی ندارید؟*/}
                    {/*    </Link>*/}

                    {/*    <Link onClick={() => navigate('/admin/signup')} underline="always" href="#" variant="body2">*/}
                    {/*        {"سـاخت حساب کاربری"}*/}
                    {/*    </Link>*/}

                    {/*</Grid>*/}
                </Box>
            </Box>
        </Grid>
    )
        ;
};

export default LoginByPassword;
